import styled from 'styled-components'

import { colors } from '../../../shared/styles/colors'

interface IContainerProps {
  backgroundColor?: string
  boxShadow?: string
}
export const Container = styled.div<IContainerProps>`
  display: flex;
  flex-direction: column;
  width: auto;
  height: 100%;
  margin: 20px 30px;
  background-color: ${props => props.backgroundColor || colors.white};
  overflow-y: auto;

  box-shadow: ${props => props.boxShadow || '0px 3px 3px rgba(0, 0, 0, 0.25)'};
  border-radius: 4px;

  @media (max-height: 1080px) {
    height: 400px;
    flex: 1;
  }
`
interface IContentProps {
  backgroundColor?: string
  padding?: string
}
export const Content = styled.div<IContentProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: ${props => props.padding || '0px 32px'};
  background-color: ${props => props.backgroundColor || colors.white};

  @media (max-height: 1080px) {
    height: auto;
    flex: 1;
  }
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 92px;
  background-color: ${colors.blue};
  padding: 24px 30px;
  align-self: flex-end;
`

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-size: 16px;
  font-weight: 700;
  padding: 30px 30px;
  color: ${colors.green};
`
